export default "__VITE_ASSET__BiLmDVGD__"